import { render, staticRenderFns } from "./ReportTableFooter.vue?vue&type=template&id=5dc6700a&scoped=true&"
import script from "./ReportTableFooter.vue?vue&type=script&lang=ts&"
export * from "./ReportTableFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc6700a",
  null
  
)

export default component.exports